module.exports = __webpack_public_path__ + "static/img/system-framework.3b0e527.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/system-framework.png
// module id = mz9s
// module chunks = 1